module.exports = __webpack_public_path__ + "media/images/photos/photo-30-e8ccd2215a299723b7de451e0fc6f7f6.jpg";